import AvatarsCount from './AvatarsCount';

export default AvatarsCount;
